import { render, staticRenderFns } from "./InvestmentHoldingsIcon.vue?vue&type=template&id=cd0aed3a&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd0aed3a')) {
      api.createRecord('cd0aed3a', component.options)
    } else {
      api.rerender('cd0aed3a', component.options)
    }
    module.hot.accept("./InvestmentHoldingsIcon.vue?vue&type=template&id=cd0aed3a&functional=true&", function () {
      api.rerender('cd0aed3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/InvestmentHoldingsIcon.vue"
export default component.exports